import { boot } from 'quasar/wrappers'

import { provideOrderEventNamespace } from 'ui-common/orders/composables/useOrderEvents'

export default boot(async ({ app }) => {
  provideOrderEventNamespace(app, 'ds-orders-energy')
})
